import React from "react";
import { MdAdd,  } from "react-icons/md";
import { Button, } from "@material-ui/core";
import FilterPlanConfig from "./Row/filter";
import DataPlanConfig from "./Row/data";
import TextField from "@material-ui/core/TextField";

import "./styles.scss";
import DragDropList from "../DragDropList";

export default function ReportConfigComponent(props) {
  const {
    valueFilterGeneral,
    onChangeFilter,
    valueFilter,
    onClickFilter,
    onClickDeleteFilter,
    valueReportData,
    onChangeConfigType,
    onChangePinColunm,
    pageReport,
    onClickReport,
    onClickDeleteData,
    onDragDrop,
  } = props;


  const arrayFilterItems = valueFilter.map((item, index) => ({
    id: `${index}`,
    content: (
      <FilterPlanConfig
        key={index}
        index={index}
        valueGeneral={valueFilterGeneral}
        valueFilter={item}
        onChange={onChangeFilter}
        onClickDelete={onClickDeleteFilter}
      />
    ),
  }));

  // const arrayReportDataItems = valueReportData.map((item, index) => ({
  //   id: `${index}`,
  //   content: (
  //     <DataPlanConfig
  //       key={index}
  //       index={index}
  //       currentValue={item}
  //       valueGeneral={valueFilterGeneral}
  //       onChangeConfigType={onChangeConfigType}
  //       onChangePinColunm={onChangePinColunm}
  //       onClickDelete={onClickDeleteData}
  //       valueReportData={valueReportData}
  //     />
  //   ),
  // }));

  return (
    <div className="plan-config col-md-12">
      <div>
        <div className="mt-2 plan-config-header">Cấu hình bộ lọc báo cáo</div>
        <div>
          {/* {valueFilter &&
            valueFilter.map((item, index) => {
              return (
                <FilterPlanConfig
                  key={index}
                  index={index}
                  valueGeneral={valueGeneral}
                  valueFilter={item}
                  onChange={onChangeFilter}
                  onClickDelete={onClickDeleteFilter}
                />
              );
            })} */}
          <DragDropList
            items={arrayFilterItems}
            onDragDrop={onDragDrop}
            type="Filter"
          ></DragDropList>
          <div className="row addConfigData">
            <Button
              variant="contained"
              className="btn-next"
              startIcon={<MdAdd />}
              onClick={onClickFilter}
            >
              Thêm
            </Button>
          </div>
        </div>
      </div>
      {/* <DragDropList
            items={arrayFilterItems}
            onDragDrop={onDragDrop}
          ></DragDropList> */}
      <div>
        <div>
          <div className="mt-2 plan-config-header">
            Cấu hình kết quả báo cáo
          </div>
          <div>
            {valueReportData &&
              valueReportData.map((item, index) => {
                return (
                  <DataPlanConfig
                    key={index}
                    index={index}
                    currentValue={item}
                    valueGeneral={valueFilterGeneral}
                    onChangeConfigType={onChangeConfigType}
                    onChangePinColunm={onChangePinColunm}
                    onClickDelete={onClickDeleteData}
                  />
                );
              })}
            {/* <DragDropList
              items={arrayReportDataItems}
              onDragDrop={onDragDrop}
              type="ReportData"
            ></DragDropList> */}
          </div>
          <div className="row">
            <div className="col-md-3">
              <TextField
                fullWidth
                id="outlined-name"
                label="Page"
                margin="dense"
                variant="outlined"
                type="number"
                InputLabelProps={{
                  shrink: true,
                  min: 1
                  //pattern: "[0-100]*",
                }}
                onChange={(e) => props.onChangePageConfig(e.target.value)}
                // onChange={(e) => props.onChange(e, props.index, "colunmName")}
                // onChange={(e) => onChange(e.target.value, index, "colunmNewName")}
                value={pageReport ?? 1}
              />
            </div>
          </div>
          <div className="row addConfigData">
            <Button
              variant="contained"
              className="btn-next"
              startIcon={<MdAdd />}
              onClick={onClickReport}
            >
              Thêm
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
